export default __webpack_public_path__ + "static/media/benefit8.51cfc373.png";